import React from 'react';

export function WavyDivider({ className = '' }: Readonly<{ className?: string }>): React.ReactElement {
  return (
    <svg
      className={className}
      width="200"
      height="12"
      viewBox="0 0 200 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0,6 Q25,2 50,6 T100,6 T150,6 T200,6"
        stroke="#C4A46B"
        strokeWidth="1.5"
        opacity="0.4"
        fill="none"
      />
    </svg>
  );
}
